import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const TrlPriceType = ({ value }) => {
  switch (value) {
    case 'C':
    case 'Q':
      return <FormattedMessage id="TRLT_UI-PERCENTAGE" />;
    case 'P':
      return <FormattedMessage id="TRLT_UI-PRICE" />;
    case 'T':
      return <FormattedMessage id="TRLT_UI-RATE" />;
    default:
      return 'PriceType Unknown';
  }
};

TrlPriceType.propTypes = {
  value: PropTypes.string,
};
